import { createApp } from 'vue'
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persistedstate';
import ToastService from "primevue/toastservice";
import ConfirmationService from 'primevue/confirmationservice';
import Toast from "primevue/toast";
import AnimateOnScroll from 'primevue/animateonscroll'
import { mixpanelService } from '@/services/mixpanel';

import '@/styles/style.css'

import App from './App.vue'
import router from './router';
import setupSentry from "./plugins/sentry";
import { enforceSessionLifetime } from '@/stores/authStore';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

// Enforce session lifetime
enforceSessionLifetime();

mixpanelService.init();
const pinia = createPinia();
pinia.use(piniaPersist);
const app = createApp(App);

if (process.env.VUE_APP_MODE !== 'development') setupSentry(app);

app.use(router);
app.use(pinia);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false || 'none',
            cssLayer: false
        }
    }
});
app.use(ToastService);
app.use(ConfirmationService);
app.directive('animateonscroll', AnimateOnScroll);
// eslint-disable-next-line vue/multi-word-component-names
app.component("Toast", Toast);

app.mount('#app');
